import { render } from "./HeaderMessage.vue?vue&type=template&id=58da0714"
import script from "./HeaderMessage.vue?vue&type=script&lang=js"
export * from "./HeaderMessage.vue?vue&type=script&lang=js"
script.render = render

export default script